<template>
  <div class="corner-figure" aria-hidden="true">
    <img src="/lihv.webp" alt="Mio 立绘" />
  </div>
</template>

<script>
export default { name: 'CornerFigure' }
</script>

<style scoped lang="scss">
.corner-figure {
  position: fixed;
  right: 12px;
  bottom: 12px;
  /* 缩小到原来的 1/2 */
  width: min(14vw, 180px);
  pointer-events: none; // 不影响页面交互
  z-index: 1100;
  opacity: .96;
}

.corner-figure img {
  width: 100%;
  height: auto;
  display: block;
  filter: drop-shadow(0 8px 24px rgba(0,0,0,.25));
  user-select: none;
  -webkit-user-drag: none;
}

@media (max-width: 768px) {
  /* 移动端同样缩小为原来的一半 */
  .corner-figure { width: min(20vw, 110px); opacity: .9; }
}
</style>
